import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MobileFrequenciaComponent } from '@features/frequencia/components/mobile-frequencia/mobile-frequencia.component';
import { MobileContextBarComponent } from '@core/context/components/mobile-context-bar.component';
import { DesempenhoEscolarComponent } from '@features/desempenho-escolar/components/desempenho-escolar.component';
import { InstrumentosAvaliacaoComponent } from '@features/instrumentos-avaliacao/components/instrumentos-avaliacao.component';
import { AcompanhamentoPedagogicoComponent } from '@features/acompanhamento-pedagogico/components/acompanhamento-pedagogico.component';
import { PlanejamentoAulaComponent } from '@features/planejamento-aula/components/planejamento-aula.component';
import { PlanoEnsinoComponent } from '@features/plano-ensino/components/plano-ensino.component';
import { pageMappingGuard } from '@core/auth/guards/page-mapping.guard';
import { SemPermissaoPageComponent } from '@infrastructure/ui/components/pages/sem-permissao-page/sem-permissao-page.component';

const routes: Routes = [
  // diario-classe é só um menu intermediário no AngularJS; no PWA vai direto pra Frequência
  {
    path: 'diario-classe',
    redirectTo: '/frequencia',
    pathMatch: 'full'
  },
  {
    path: 'frequencia',
    component: MobileFrequenciaComponent,
    canActivate: [pageMappingGuard],
    data: {
      title: 'Frequência Mobile',
      pageMapping: 'RegistroFrequenciaAulaPageMapping'
    }
  },
  {
    path: 'desempenho',
    component: DesempenhoEscolarComponent,
    canActivate: [pageMappingGuard],
    data: {
      title: 'Desempenho',
      pageMapping: 'RegistroAvaliacaoPageMapping'
    }
  },
  {
    path: 'instrumentos-avaliacao',
    component: InstrumentosAvaliacaoComponent,
    canActivate: [pageMappingGuard],
    data: {
      title: 'Instrumentos de avaliação',
      pageMapping: 'RegistroAvaliacaoPageMapping'
    }
  },
  {
    path: 'acompanhamento-pedagogico',
    component: AcompanhamentoPedagogicoComponent,
    canActivate: [pageMappingGuard],
    data: {
      title: 'Acompanhamento Pedagógico',
      pageMapping: 'AcompanhamentoPedagogicoPageMapping'
    }
  },
  {
    path: 'plano-ensino',
    component: PlanoEnsinoComponent,
    data: { title: 'Plano de Ensino' }
  },
  {
    path: 'planejamento-aula',
    component: PlanejamentoAulaComponent,
    canActivate: [pageMappingGuard],
    data: {
      title: 'Planejamentos de Aula',
      pageMapping: 'ConteudoPlanejadoPageMapping'
    }
  },
  {
    path: 'context-bar',
    component: MobileContextBarComponent,
    data: { title: 'Barra de Contexto Mobile' }
  },
  {
    path: 'sem-permissao',
    component: SemPermissaoPageComponent,
    data: { title: 'Sem permissão' }
  },
  {
    path: '',
    redirectTo: '/frequencia',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/frequencia'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false, // true para debug
    useHash: true,
    initialNavigation: 'enabledNonBlocking', // permite pintar a shell imediatamente
    onSameUrlNavigation: 'reload',
    canceledNavigationResolution: 'replace'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
